import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import DashboardEstoque from "./pages/DashboardEstoque";
import DashboardCartas from "./pages/DashboardCartas";
import Agendas from "./pages/Agendas";
import AgendasNovo from "./pages/AgendasNovo";
import Usuarios from "./pages/Usuarios";
import Relatorios from "./pages/Relatorios";
import RelatorioNovo from "./pages/RelatorioNovo";
import Monitoramento from "./pages/Monitoramento";
import MonitoramentoNovo from "./pages/MonitoramentoNovo";
import MonitoramentoMensal from "./pages/MonitoramentoMensal";
import Instituicoes from "./pages/Instituicoes";
import InstituicoesNovo from "./pages/InstituicoesNovo";
import Gestor from "./pages/Gestor";
import GestorNovo from "./pages/GestorNovo";
import Visitas from "./pages/Visitas";
import VisitasNovo from "./pages/VisitasNovo";
import Estoque from "./pages/Estoque";
import EstoqueNovo from "./pages/EstoqueNovo";
import EstoqueSaida from "./pages/EstoqueSaida";
import EstoqueAtual from "./pages/EstoqueAtual";
import EstoqueItens from "./pages/EstoqueItens";
import Cartas from "./pages/Cartas";
import CartasNovo from "./pages/CartasNovo";


import './styles/main.css';

function PrivateRoute({ children }) {
  const tokens = localStorage.getItem("authTokens");
  return tokens ? children : <Navigate to="/login" />;
}

// Componente que escolhe qual Dashboard renderizar com base no grupo do usuário
function DashboardRoute() {
  const { user } = useContext(AuthContext);

  // Enquanto o usuário não estiver carregado, exibe um carregamento
  if (!user) {
    return (
      <div>
        <div className="progress progress-2">
          <div className="progress-bar progress-bar-indeterminate bg-secondary"></div>
        </div>
      </div>
    );
  }

  switch (user.group) {
    case "estoque_admin":
    case "estoque":
    case "estoque_ver":
      return <DashboardEstoque />;
    case "cartasvisitas":
      return <DashboardCartas />;
    default:
      return <Dashboard />;
  }
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Dashboard principal: renderiza o Dashboard personalizado conforme o grupo */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <DashboardRoute />
              </PrivateRoute>
            }
          />
          <Route
            path="/visitas"
            element={
              <PrivateRoute>
                <Visitas />
              </PrivateRoute>
            }
          />
          <Route
            path="/visitas/novo"
            element={
              <PrivateRoute>
                <VisitasNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/agendas"
            element={
              <PrivateRoute>
                <Agendas />
              </PrivateRoute>
            }
          />
          <Route
            path="/agendas/novo"
            element={
              <PrivateRoute>
                <AgendasNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/monitoramento"
            element={
              <PrivateRoute>
                <Monitoramento />
              </PrivateRoute>
            }
          />
          <Route
            path="/monitoramento/novo"
            element={
              <PrivateRoute>
                <MonitoramentoNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/monitoramento/mensal"
            element={
              <PrivateRoute>
                <MonitoramentoMensal />
              </PrivateRoute>
            }
          />
          <Route
            path="/instituicoes"
            element={
              <PrivateRoute>
                <Instituicoes />
              </PrivateRoute>
            }
          />
          <Route
            path="/instituicoes/novo"
            element={
              <PrivateRoute>
                <InstituicoesNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/gestor"
            element={
              <PrivateRoute>
                <Gestor />
              </PrivateRoute>
            }
          />
          <Route
            path="/gestor/novo"
            element={
              <PrivateRoute>
                <GestorNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <PrivateRoute>
                <Usuarios />
              </PrivateRoute>
            }
          />
          <Route
            path="/relatorios"
            element={
              <PrivateRoute>
                <Relatorios />
              </PrivateRoute>
            }
          />
          <Route
            path="/relatorios/novo"
            element={
              <PrivateRoute>
                <RelatorioNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/estoque"
            element={
              <PrivateRoute>
                <Estoque />
              </PrivateRoute>
            }
          />
          <Route
            path="/estoque/novo"
            element={
              <PrivateRoute>
                <EstoqueNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/estoque/saida"
            element={
              <PrivateRoute>
                <EstoqueSaida />
              </PrivateRoute>
            }
          />
          <Route
            path="/estoque/atual"
            element={
              <PrivateRoute>
                <EstoqueAtual />
              </PrivateRoute>
            }
          />
          <Route
            path="/estoque/itens"
            element={
              <PrivateRoute>
                <EstoqueItens />
              </PrivateRoute>
            }
          />
          <Route
            path="/cartas"
            element={
              <PrivateRoute>
                <Cartas />
              </PrivateRoute>
            }
          />
          <Route
            path="/cartas/novo"
            element={
              <PrivateRoute>
                <CartasNovo />
              </PrivateRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* Outras rotas, se houver */}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;